var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fpui-helper pointer"},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.options),expression:"options"}],staticClass:"fpui fpui-ask",class:_vm.className})])}
var staticRenderFns = []

export { render, staticRenderFns }